






















































import { Vue, Component } from 'vue-property-decorator'
import sample from 'lodash/sample'

const assetsUrl = process.env.VUE_APP_ASSETS_URL
const backgroundPaths = [
  '/videos/background001',
  '/videos/background002',
  '/videos/background003',
  '/videos/background004',
  '/videos/background005',
  '/videos/background006',
  '/videos/background007',
  '/videos/background008'
]

@Component
export default class App extends Vue {
  private background: {
    webm?: string,
    mp4?: string,
    isReady: boolean
  } = {
    isReady: false
  }

  get isTool () {
    return this.$route.matched.some(r => r.name === 'tools')
  }

  created () {
    const backgroundKey = sample(backgroundPaths)

    this.background = {
      ...this.background,
      webm: assetsUrl + backgroundKey + '.webm',
      mp4: assetsUrl + backgroundKey + '.mp4'
    }
  }

  onCanPlayThrough () {
    this.background.isReady = true
  }
}
